import { Component } from '@angular/core';

@Component({
  selector: 'app-exchange-markets',
  templateUrl: './exchange-markets.component.html',
  styleUrls: ['./exchange-markets.component.scss']
})
export class ExchangeMarketsComponent {

}
